export default __webpack_public_path__ + "static/media/ic-sm-sowing-4.934761c1.svg";